<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Governing Body</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="javascript:void(0);">Governing Body</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="core-value ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <h4 class="yellow-color fw-bold">Governing Body of the G H Raisoni Educational &amp; Medical Foundation</h4>
        <strong>Society Regn No. Maharashtra 312/2006(Nagpur) Dtd 23-05-2006 Trust Regn. No. F-22519 (Nagpur ) Dtd.
          26-07-2007.</strong>
        <div class="table-responsive mt-2">
          <table width="100%" class="table table-bordered table-striped">
            <thead>
              <tr class="default-table">
                <th>Sr. No.</th>
                <th>Executive Committee</th>
                <th>Designation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Shri. Sunil Gyanchandji Raisoni</td>
                <td>President</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Shri. Sudharkar Jagdale</td>
                <td>Secretary</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Sadabai Raisoni Educational &amp; Medical Research Foundation (Represented by: Miss Mragna Gupta)
                </td>
                <td>Member</td>
              </tr>
              <tr>
                <td>4</td>
                <td>G. H. Raisoni Technology Business Incubator Foundation(Represented by: Shri.Prabhakar Fulkar) </td>
                <td>Member</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Orange City Educational &amp;Medical Research Foundation (Represented by: Shri.Gorden Weller)</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>6</td>
                <td>SGR Educational &amp; Medical Research Foundation(Represented by : Shri Rajendra Gaur)</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>7</td>
                <td>GHR Sons Educational &amp; Medical Research Foundation (Represented by: Shri. Raju Sakharkar)</td>
                <td>Member</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
